import {
  RelatedOfferDetails,
  SelectedPlan,
} from 'components/shop/MobilePlans/typings/plans';
import { removePrices } from 'components/shop/MobilePlans/utils/removePrices.utils';

const buildDescriptionText = ({
  selectedPlan,
  kidsPlan,
  companionPlan,
}: {
  selectedPlan: SelectedPlan;
  kidsPlan: RelatedOfferDetails;
  companionPlan?: RelatedOfferDetails;
}) => {
  const { name: kidsPlanName, price: kidsPlanPrice } = kidsPlan;
  const kidsPlanBasePrice = kidsPlanPrice?.basePrice;
  if (!kidsPlanBasePrice || !kidsPlanName) {
    return null;
  }

  const kidsPlanDescription = `${removePrices(
    kidsPlanName,
  )} for $${kidsPlanBasePrice} each`;
  if (companionPlan) {
    const { name: companionPlanName, price: companionPlanPrice } =
      companionPlan;
    const companionPlanBasePrice = companionPlanPrice?.basePrice;

    if (!companionPlanBasePrice || !companionPlanName) {
      return null;
    }

    return `By purchasing a ${removePrices(
      selectedPlan.planName,
    )}, you can add up to four ${removePrices(
      companionPlanName,
    )} for $${companionPlanBasePrice} each and ${kidsPlanDescription}.`;
  }

  return `You can add up to four ${kidsPlanDescription}.`;
};

export default buildDescriptionText;
